import React from 'react';
import styled from 'styled-components';
import image from '../../img/me.webp';

export const ImageSection = () => {
  return (
    <ImageSectionStyled>
      <div className='left-content'>
        <img src={image} alt='' />
      </div>
      <div className='right-content'>
        <h4>
          Who is <span>Juanma Rodriguez</span>?
        </h4>
        <p className='paragraph'>
          I'm a Senior Full-Stack Developer with over 6 years of experience
          building modern, scalable, and high-performance applications.
          Specializing in React, React Native, Node.js and TypeScript, I partner
          with startups and growing teams to transform ideas into
          production-ready web & mobile applications. I balance speed,
          reliability and real ROI at every stage.
        </p>
        <p className='paragraph'>
          <h3>
            <span>What I do best:</span>
          </h3>
          <ul>
            <li>
              • Build web and mobile applications using modern technologies
            </li>
            <li>• Design scalable and maintainable system architectures</li>
            <li>
              • Lead development teams with code reviews, mentoring, and task
              delegation
            </li>
          </ul>
        </p>
        <p className='paragraph'>
          I’m passionate about clean code, performance, and helping clients
          solve real problems with technology. Whether you're building from
          scratch or need a reliable developer to level up your existing product
          — I’m here to help. Let’s build something great together
        </p>
        <table
          style={{ width: '100%', marginBottom: '1rem', marginTop: '1rem' }}
        >
          <tr>
            <td>Full Name</td>
            <td>Juan Marcelo Rodriguez</td>
          </tr>
          <tr>
            <td>Age</td>
            <td>29</td>
          </tr>
          <tr>
            <td>Nationality</td>
            <td>Argentine</td>
          </tr>
          <tr>
            <td>Languages</td>
            <td>Spanish, English</td>
          </tr>
          <tr>
            <td>Location</td>
            <td>Buenos Aires, Argentina</td>
          </tr>
          <tr>
            <td>Service</td>
            <td>
              <ul>
                <li>• Digital Product Development</li>
                <li>• Architecture & Scalability</li>
                <li>• Prompt Engineering</li>
                <li>• Technical Leadership & Team Management</li>
                <li>• Consulting & Discovery</li>
                <li>• Performance Optimization</li>
                <li>• Maintenance, Support & Evolution</li>
                <li>• UI/UX Design Support</li>
              </ul>
            </td>
          </tr>
        </table>
      </div>
    </ImageSectionStyled>
  );
};

const ImageSectionStyled = styled.div`
  margin-top: 5rem;
  display: flex;
  @media screen and (max-width: 1000px) {
    flex-direction: column;
    .left-content {
      margin-bottom: 2rem;
    }
  }
  .left-content {
    flex: 1;
    img {
      width: 90%;
      object-fit: cover;
    }
  }
  .right-content {
    flex: 1;
    h4 {
      font-size: 2rem;
      color: var(--white-color);
      span {
        font-size: 2rem;
      }
    }
    .paragraph {
      padding: 0.8rem 0;
    }

    th,
    td {
      padding: 0.8rem;
      border: 2px solid var(--border-color);
      background-color: var(--background-dark-grey);
      &:hover {
        border: 2px solid var(--primary-color);
      }
    }

    .about-info {
      display: flex;
      padding-bottom: 1.4rem;
      .info-title {
        padding-right: 3rem;
        p {
          font-weight: 600;
        }
      }
      .info-title,
      .info {
        p {
          padding: 0.3rem 0;
        }
      }
    }
  }
`;
